<div class="card">
    <div class="card-body">
      <h5 class="card-title">CURSO: {{cousesData.cou_vc_name}}</h5>
      <fieldset class="col-12">
      <legend>Listado</legend>
  
      <div class="card">
        <div class="card-body">
          
          <div class="mat-elevation-z8 table-responsive">
            <table mat-table [dataSource]="dataSource" matSort>
              <!-- Progress Column -->
              <ng-container matColumnDef="per_vc_document_number">
                <th style="width: 15%;" mat-header-cell *matHeaderCellDef mat-sort-header> Documento </th>
                <td mat-cell *matCellDef="let row"> {{row.per_vc_document_number}} </td>
              </ng-container>
          
              <!-- Name Column -->
              <ng-container matColumnDef="per_vc_full_name">
                <th style="width: 45%;" mat-header-cell *matHeaderCellDef mat-sort-header> Nombres Completos </th>
                <td mat-cell *matCellDef="let row"> {{row.per_vc_full_name}} </td>
              </ng-container>
              <ng-container matColumnDef="per_vc_cellphone">
                <th style="width: 15%;" mat-header-cell *matHeaderCellDef mat-sort-header> Telefono </th>
                <td mat-cell *matCellDef="let row"> {{row.per_vc_cellphone}} </td>
              </ng-container>
              
              <ng-container matColumnDef="opcion">
                <th  style="width: 15%;" mat-header-cell *matHeaderCellDef> Opciones</th>
                <td  mat-cell *matCellDef="let element">
                  <a  (click)="showFileCourses(element)" class="pr-2"><i class="fa fa-remove"></i> Archivos</a>
                  <a   class="pr-2"><i class="fa fa-eye"></i> Chat</a>
                </td>
              </ng-container>
  
              <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
          
              <!-- Row shown when there is no matching data. -->
              <tr class="mat-row" *matNoDataRow>
                <td class="mat-cell" colspan="4">No data matching the filter</td>
              </tr>
            </table>
          
            <mat-paginator #paginatorDatasource [pageSizeOptions]="[5, 10, 25, 100]"></mat-paginator>
          </div>
  
        </div>
      </div>
  
      </fieldset>
    </div>
  </div>
